import styled from 'styled-components';

import Dropdown, { DropdownContent } from 'react-simple-dropdown';
import { Link } from 'react-router-dom';

import { getThemeProp } from 'theme';

export const StyledHeaderIcon = styled.i`
  border-radius: 5px;
  color: ${getThemeProp('colors.solitudeGrey')};
  display: inline-block;
  padding: 4px 5px 0;
  vertical-align: middle;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: ${getThemeProp('colors.moonRakerBlue')};
  }
`;

export const StyledHeaderMenuItemIcon = styled.i`
  color: ${getThemeProp('colors.moodyBlue2')};
  font-size: 16px;
  text-align: center;
  transform: translateY(2px);
  width: 16px;
`;

export const StyledHeaderMenuItemLabel = styled.span`
  color: ${getThemeProp('colors.eastBayBlue2')};
  flex: 1;
  font-size: 12px;
  padding-left: 14px;
  text-align: left;
`;

export const StyledHeaderMenuItem = styled(Link)`
  align-items: center;
  color: ${getThemeProp('colors.fiordGrey')};
  display: flex;
  font-size: 12px;
  justify-content: flex-start;
  line-height: 28px;
  padding: 0 16px;
  width: 100%;

  &:hover {
    background-color: ${getThemeProp('colors.havelockBlue')};

    ${StyledHeaderMenuItemIcon},
    ${StyledHeaderMenuItemLabel} {
      color: ${getThemeProp('colors.white')};
    }
  }

  &[disabled] {
    cursor: not-allowed;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  display: inline-block;
  position: relative;

  .dropdown__trigger {
    display: inline-block;
    line-height: 46px;
  }
`;

export const StyledDropdownContent = styled(DropdownContent)`
  &&& {
    background-color: ${getThemeProp('colors.white')};
    border: 1px solid ${getThemeProp('colors.mercuryGrey')};
    border-radius: 4px;
    box-shadow: 5px 10px 20px 0 rgba(0, 0, 0, 0.19);
    margin-top: 0;
    padding: 0;
    position: absolute;
    right: 17px;
    top: 39px;
    width: 200px;
    z-index: 999;

    &:after {
      border-color: transparent transparent ${getThemeProp('colors.white')}
        transparent;
      border-style: solid;
      border-width: 0 12px 10px 12px;
      content: '';
      height: 0;
      position: absolute;
      right: 18px;
      top: -6px;
      width: 0;
    }
  }
`;

export const StyledDropdownContentHeader = styled.div`
  border-bottom: 1px solid ${getThemeProp('colors.mercuryGrey')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 16px 11.5px;
  text-align: left;
`;

export const StyledDropdownContentBody = styled.div`
  padding: 7px 0;
`;

export const StyledDropdownContentHeaderTitle = styled.div`
  color: ${getThemeProp('colors.manateeGrey2')};
  font-size: 13px;
  line-height: 16px;
`;

export const StyledMenuItem = styled.div`
  align-items: center;
  color: ${getThemeProp('colors.fiordGrey')};
  display: flex;
  font-size: 12px;
  justify-content: flex-start;
  line-height: 28px;
  padding: 0 16px;
  width: 100%;

  &:hover {
    background-color: ${getThemeProp('colors.havelockBlue')};

    * {
      color: ${getThemeProp('colors.white')};
    }
  }

  &[disabled] {
    cursor: not-allowed;
  }
`;
